import React, { useEffect, useState } from 'react'
import { makeStyles, createStyles, Typography } from '@material-ui/core'
import dayjs from 'dayjs'
import Button from '../Button/Button'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import { connect } from 'react-redux'
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)
import clsx from 'clsx'
import Price from '../Shop/Price'
import CMSText from '../Global/CMSText'
import { useRouter } from 'next/router'

const useStyles = makeStyles((theme) =>
  createStyles({
    orderHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'left',
    },
    smallerText: {
      fontSize: theme.typography.pxToRem(10),
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(9),
      },
    },
    card: {
      background: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(3),
    },
    smallButton: {
      padding: theme.spacing(1, 1),
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(11),
        padding: theme.spacing(0.4, 0.4),
      },
    },
    priceTotal: {
      marginLeft: theme.spacing(2),
    },
    subscription: {
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(13),
      },
    },
    price: {
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(13),
      },
    },
    returnButton: {
      margin: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(0.4),
      },
    },
    cancelButton: {
      width: 150,
      textAlign: 'center',
      cursor: 'pointer',
      '& .MuiTypography-root': {
        [theme.breakpoints.down('md')]: {
          fontSize: '80%',
        },
      },
    },
    spacing: {
      marginLeft: 19,
    },
    subscriptionBox: {
      margin: theme.spacing(0.4),
    },
    mobileLinkToModif: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    simpleMargin: {
      margin: theme.spacing(1),
    },
    subDone: {
      maxWidth: 400,
      [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacing(3),
      },
    },
  })
)

type Tprops = {
  isFunnel
  allProducts
  isClassicSub
  isSmallScreen
  isModifying
  doc
  t
  cancelReturn
  setIsModifying
  contract
  totalCurrent
  newTotal
  isInStore
  currentSubscriptionPrice
  currentSubscriptionMaxItems
  newSubscriptionPrice
  newSubscriptionMaxItems
  settings
  orders
  parameters
}

const mapStateToProps = (state) => ({
  promotions: state.promotions,
  parameters: state.parameters,
})

const SubscriptionListHeader = ({
  isFunnel,
  allProducts,
  isClassicSub,
  isSmallScreen,
  isModifying,
  doc,
  isInStore,
  t,
  cancelReturn,
  setIsModifying,
  contract,
  totalCurrent,
  newTotal,
  currentSubscriptionPrice,
  currentSubscriptionMaxItems,
  newSubscriptionPrice,
  newSubscriptionMaxItems,
  settings,
  orders,
  parameters,
}: Tprops) => {
  const classes = useStyles()
  const router = useRouter()
  const displayFlexPrice = settings?.display_flex_price_a_day
  const minSubDuration = parseInt(parameters?.items?.minSubscriptionDays)
  const [minSubscriptionDate, setMinSubscriptionDate] = useState(
    dayjs().add(30, 'day')
  )
  const isDisabled = dayjs().isBefore(minSubscriptionDate)

  useEffect(() => {
    if (orders?.length > 0)
      setMinSubscriptionDate(
        dayjs(orders[orders?.length - 1]?.startLeasingDate, 'DD/MM/YYYY').add(
          minSubDuration,
          'day'
        )
      )
  }, [orders])

  return (
    <>
      {!isFunnel && allProducts.length > 0 && (
        <>
          {!isClassicSub ? (
            <>
              {isSmallScreen && (
                <div className={classes.mobileLinkToModif}>
                  {!isModifying ? (
                    <div>
                      <Button
                        data-testid={'returnBtn'}
                        className={classes.simpleMargin}
                        onClick={() =>
                          doc?.data?.handle_return_cta?.[0]?.spans?.[0]?.data
                            ?.url
                            ? router.push(
                                doc?.data?.handle_return_cta?.[0]?.spans?.[0]
                                  ?.data?.url
                              )
                            : setIsModifying(true)
                        }
                        color={'primary'}
                        disabled={isDisabled}
                        variant={'text'}
                      >
                        <Typography variant={'body2'}>
                          <CMSText
                            asText
                            data={doc?.data?.handle_return_cta}
                            defaultText={t(
                              'texts:subscription_order:change_cta'
                            )}
                          />
                        </Typography>
                      </Button>
                    </div>
                  ) : (
                    <div>
                      <Button
                        data-testid={'cancelBtn'}
                        color={'primary'}
                        className={classes.simpleMargin}
                        onClick={cancelReturn}
                        variant={'text'}
                      >
                        <Typography variant={'body2'}>
                          <CMSText
                            asText
                            data={doc?.data?.cancel_cta}
                            defaultText={t(
                              'texts:subscription_order:cancel_cta'
                            )}
                          />
                        </Typography>
                      </Button>
                    </div>
                  )}
                </div>
              )}
              <div
                className={clsx(classes.orderHeader, isInStore && classes.card)}
              >
                <div className={classes.subscriptionBox}>
                  <Typography variant={'h4'} className={classes.subscription}>
                    <CMSText
                      asText
                      data={doc?.data?.my_subscription}
                      defaultText={t(
                        'texts:subscription_order:my_subscription'
                      )}
                    />
                  </Typography>
                  {contract && (
                    <Typography
                      variant={'body2'}
                      className={classes.smallerText}
                    >
                      <CMSText
                        asText
                        data={doc?.data?.taken_every}
                        defaultText={t('texts:subscription_order:taken_every')}
                      />
                      &nbsp;
                      {dayjs(contract?.startLeasingDate).date()}&nbsp;
                      <CMSText
                        asText
                        data={doc?.data?.of_the_month}
                        defaultText={t('texts:subscription_order:of_the_month')}
                      />
                    </Typography>
                  )}
                </div>
                <div className={classes.priceTotal}>
                  <Typography
                    variant={'h3'}
                    color={'secondary'}
                    className={classes.price}
                  >
                    <Price
                      amount={totalCurrent}
                      isShort={false}
                      showDayOrMonth
                      dayOrMonth={settings.day_or_month}
                      amountNotDivided
                      displayFlexPrice={displayFlexPrice}
                    />
                  </Typography>
                </div>
                {isSmallScreen && isModifying && (
                  <>
                    <div className={classes.returnButton}>
                      <ArrowForwardIcon />
                    </div>
                    <div className={classes.priceTotal}>
                      <Typography
                        variant={'h3'}
                        color={'secondary'}
                        className={classes.price}
                      >
                        <Price
                          amount={newTotal}
                          isShort={false}
                          showDayOrMonth
                          dayOrMonth={settings.day_or_month}
                          amountNotDivided
                          displayFlexPrice={displayFlexPrice}
                        />
                      </Typography>
                      <Typography
                        variant={'body2'}
                        className={classes.smallerText}
                      >
                        <CMSText
                          asText
                          data={doc?.data?.per_month}
                          defaultText={t('texts:subscription_order:per_month')}
                        />
                      </Typography>
                    </div>
                  </>
                )}
                {!isSmallScreen && (
                  <>
                    {!isModifying ? (
                      <div className={classes.returnButton}>
                        <Button
                          variant={'outlined'}
                          color={'secondary'}
                          className={classes.smallButton}
                          size={'small'}
                          onClick={() =>
                            doc?.data?.handle_return_cta?.[0]?.spans?.[0]?.data
                              ?.url
                              ? router.push(
                                  doc?.data?.handle_return_cta?.[0]?.spans?.[0]
                                    ?.data?.url
                                )
                              : setIsModifying(true)
                          }
                          data-testid={'returnBtn'}
                          disabled={isDisabled}
                        >
                          <CMSText
                            asText
                            data={doc?.data?.handle_return_cta}
                            defaultText={t(
                              'texts:subscription_order:handle_return_cta'
                            )}
                          />
                        </Button>
                      </div>
                    ) : (
                      <>
                        <div className={classes.returnButton}>
                          <ArrowForwardIcon />
                        </div>
                        <>
                          <div className={classes.priceTotal}>
                            <>
                              <Typography variant={'h3'} color={'secondary'}>
                                <Price
                                  amount={newTotal}
                                  isShort={false}
                                  showDayOrMonth
                                  dayOrMonth={settings.day_or_month}
                                  amountNotDivided
                                  displayFlexPrice={displayFlexPrice}
                                />
                              </Typography>
                            </>
                          </div>
                          <div className={classes.cancelButton}>
                            <Typography
                              data-testid={'cancelBtn'}
                              variant={'body2'}
                              color={'secondary'}
                              onClick={cancelReturn}
                            >
                              <CMSText
                                asText
                                data={doc?.data?.cancel_cta}
                                defaultText={t(
                                  'texts:subscription_order:cancel_cta'
                                )}
                              />
                            </Typography>
                          </div>
                        </>
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          ) : (
            <div className={classes.orderHeader}>
              <div>
                <Typography variant={'body2'} className={classes.smallerText}>
                  <CMSText
                    asText
                    data={doc?.data?.my_subscription}
                    defaultText={t('texts:subscription_order:my_subscription')}
                  />
                </Typography>
                <Typography variant={'h4'} className={classes.subscription}>
                  <CMSText
                    asText
                    data={doc?.data?.forfaits}
                    defaultText={t('texts:subscription_order:rate')}
                  />
                  &nbsp;
                  {currentSubscriptionMaxItems}&nbsp;
                  <CMSText
                    asText
                    data={doc?.data?.articles_max}
                    defaultText={t('texts:subscription_order:articles_max')}
                  />
                </Typography>
                <Typography
                  variant={'h4'}
                  color={'secondary'}
                  className={classes.subscription}
                >
                  <Price
                    amount={currentSubscriptionPrice}
                    isShort={false}
                    showDayOrMonth
                    dayOrMonth={settings.day_or_month}
                    displayFlexPrice={displayFlexPrice}
                  />
                </Typography>
                <Typography
                  variant={'body2'}
                  color={'secondary'}
                  className={classes.smallerText}
                >
                  <CMSText
                    asText
                    data={doc?.data?.taken_every}
                    defaultText={t('texts:subscription_order:taken_every')}
                  />
                  &nbsp;
                  {contract && dayjs(contract?.startLeasingDate).date()}&nbsp;
                  <CMSText
                    asText
                    data={doc?.data?.of_the_month}
                    defaultText={t('texts:subscription_order:per_month')}
                  />
                </Typography>
              </div>
              {!isModifying ? (
                <div className={classes.returnButton}>
                  <Button
                    data-testid={'returnBtn'}
                    variant={'outlined'}
                    color={'secondary'}
                    size={isSmallScreen ? 'small' : 'medium'}
                    onClick={() =>
                      doc?.data?.handle_return_cta?.[0]?.spans?.[0]?.data?.url
                        ? router.push(
                            doc?.data?.handle_return_cta?.[0]?.spans?.[0]?.data
                              ?.url
                          )
                        : setIsModifying(true)
                    }
                    disabled={isDisabled}
                  >
                    <CMSText
                      asText
                      data={doc?.data?.handle_return_cta}
                      defaultText={t(
                        'texts:subscription_order:handle_return_cta'
                      )}
                    />
                  </Button>
                </div>
              ) : (
                <>
                  <div className={classes.returnButton}>
                    <ArrowForwardIcon />
                  </div>
                  <div>
                    {newSubscriptionPrice / 100 === 0 ? (
                      <div className={classes.subDone}>
                        <Typography
                          variant={'h4'}
                          color={'secondary'}
                          className={classes.subscription}
                        >
                          <CMSText
                            asText
                            data={doc?.data?.sub_finished_title}
                            defaultText={t(
                              'texts:subscription_order:sub_finished:title'
                            )}
                          />
                        </Typography>
                        {!isSmallScreen && (
                          <Typography
                            variant={'body2'}
                            color={'secondary'}
                            component={'div'}
                            className={classes.smallerText}
                          >
                            <CMSText
                              data={doc?.data?.sub_finished_desc}
                              defaultText={t(
                                'texts:subscription_order:sub_finished:desc'
                              )}
                            />
                          </Typography>
                        )}
                      </div>
                    ) : (
                      <>
                        <Typography
                          variant={'body2'}
                          className={classes.smallerText}
                        >
                          <CMSText
                            asText
                            data={doc?.data?.my_new_subscription}
                            defaultText={t(
                              'texts:subscription_order:my_new_subscription'
                            )}
                          />
                        </Typography>
                        <Typography
                          variant={'h4'}
                          className={classes.subscription}
                        >
                          <CMSText
                            asText
                            data={doc?.data?.forfaits}
                            defaultText={t('texts:subscription_order:rate')}
                          />
                          &nbsp;
                          {newSubscriptionMaxItems}&nbsp;
                          <CMSText
                            asText
                            data={doc?.data?.articles_max}
                            defaultText={t(
                              'texts:subscription_order:articles_max'
                            )}
                          />
                        </Typography>
                        <Typography
                          variant={'h4'}
                          color={'secondary'}
                          className={classes.subscription}
                        >
                          <Price
                            amount={newSubscriptionPrice}
                            isShort={false}
                            showDayOrMonth
                            dayOrMonth={settings.day_or_month}
                            displayFlexPrice={displayFlexPrice}
                          />
                        </Typography>
                        <Typography
                          variant={'body2'}
                          color={'secondary'}
                          className={classes.smallerText}
                        >
                          <CMSText
                            asText
                            data={doc?.data?.taken_every}
                            defaultText={t(
                              'texts:subscription_order:taken_every'
                            )}
                          />
                          &nbsp;
                          {dayjs(contract?.startLeasingDate).date()}&nbsp;
                          <CMSText
                            asText
                            data={doc?.data?.of_the_month}
                            defaultText={t(
                              'texts:subscription_order:of_the_month'
                            )}
                          />
                        </Typography>
                      </>
                    )}
                  </div>
                  <div className={classes.cancelButton}>
                    <Typography
                      data-testid={'cancelBtn'}
                      variant={'body2'}
                      color={'secondary'}
                      onClick={cancelReturn}
                    >
                      <CMSText
                        asText
                        data={doc?.data?.cancel_cta}
                        defaultText={t('texts:subscription_order:cancel_cta')}
                      />
                    </Typography>
                  </div>
                </>
              )}
            </div>
          )}
        </>
      )}
    </>
  )
}

export default connect(mapStateToProps)(SubscriptionListHeader)
